import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { TextAlignKinds } from "../../../../base/domain/drawing";
import { ITextJoinBehavior, IObjectsControllable, ILinkedPageObjectSpecifiable } from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IJoinTextObject } from "../objects";
import { ITextJoinBehaviorPropertyEditable } from "../properties";
import { AbstractCalculatableObjectEditor } from "./AbstractCalculatableObjectEditor";

export class JoinTextObjectEditor extends AbstractCalculatableObjectEditor<IJoinTextObject> implements ITextJoinBehaviorPropertyEditable {
  constructor(source: IJoinTextObject | JoinTextObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._multiLineBehavior = this.createMultiLineBehaviorPropertyEditor();
    this._textJoinBehavior = this.createPropertyEditor(s => s.textJoinBehavior, (s, v) => s.textJoinBehavior = v);
    this._itemSelectTriggerBehavior = this.createPropertyEditor(s => s.itemSelectTriggerBehavior, (s, v) => s.itemSelectTriggerBehavior = v);
    this._emptyAlertBehavior = this.createEmptyAlertBehaviorPropertyEditor(s => false);
  }

  protected _textJoinBehavior: IPropertyEditable<ITextJoinBehavior>;
  protected _itemSelectTriggerBehavior: IPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>>;

  textJoinBehavior(): IPropertyEditable<ITextJoinBehavior> {
    return this._textJoinBehavior;
  }

  itemSelectTriggerBehavior(): IPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>> {
    return this._itemSelectTriggerBehavior;
  }

  getTypeName(): string {
    return "結合テキスト";
  }

  getSelectableAlignmentKinds(): TextAlignKinds[] {
    return this._specification.objects.jointext.alignmentKinds;
  }

  clone(): IFormatObjectEditable {
    return new JoinTextObjectEditor(this);
  }
}
